import React from 'react'
import PropTypes from 'prop-types'

import Error from 'components/Error'

import { withApollo } from 'helpers/graphql'
import { initialHeaderRequest } from 'helpers/nextjsApiCall'

import ContactRequest from 'apps/ContactRequest'

const ContactRequestLoader = withApollo((props) => {
  const { statusCode } = props

  if (statusCode) {
    return <Error {...props} />
  }

  return (
    <ContactRequest {...props} />
  )
})

ContactRequestLoader.getInitialProps = async (props) => {
  const headerResult = await initialHeaderRequest(props)

  return {
    ...headerResult,
    providerSlug: props.query.slug,
    skipDeferringStyles: true,
    forceEnableIntercom: true,
    renderSeoTags: false,
  }
}

ContactRequestLoader.propTypes = {
  statusCode: PropTypes.number,
}

export default ContactRequestLoader
